import React from "react";
import { STHead, STNewsFeed } from "@/components";
import { getPageContentBySlug } from "@/actions";

export async function getStaticProps() {
  let pageData = null;
  try {
    const res = await getPageContentBySlug("news-blogs");
    if (res?.success && res?.data) {
      pageData = res.data;
    }
  } catch (error) {
    console.error("Error fetching news-feed page data:", error);
  }

  return {
    props: {
      pageData,
    },
    revalidate: 60,
  };
}

const NewsFeed = ({ pageData }) => {
  const pageContent = pageData?.page?.page_content || {};
  const imageUrlBase = pageData?.imageUrl || "https://sustanix.com/";

  const metaTitle = pageContent.meta_title || "News Feed";
  const metaDescription =
    pageContent.meta_description ||
    "Stay updated with the latest news, articles, and insights from Sustanix.";
  const metaKeywords =
    pageContent.meta_keywords ||
    "Sustanix news, articles, green chemistry, sustainable additives";

  const ogTitle =
    pageContent.og_title ||
    metaTitle ||
    "Catch up on the latest news & blogs from Sustanix";
  const ogDescription =
    pageContent.og_description ||
    metaDescription ||
    "Curious about what we are upto at Sustanix, this page has all our updates from lab to events to industry";
  const ogKeywords =
    pageContent.og_keywords ||
    metaKeywords ||
    "Sustanix news, articles, green chemistry, sustainable additives";

  const getOgImage = () => {
    if (pageContent.og_image_url) return pageContent.og_image_url;
    if (pageContent.og_image) {
      if (
        pageContent.og_image.startsWith("http://") ||
        pageContent.og_image.startsWith("https://") ||
        pageContent.og_image.startsWith("/")
      ) {
        return pageContent.og_image;
      }
      return imageUrlBase.endsWith("/")
        ? `${imageUrlBase}${pageContent.og_image}`
        : `${imageUrlBase}/${pageContent.og_image}`;
    }
    return "https://sustanix.com/opengraph-image.webp";
  };

  const ogImage = getOgImage();

  return (
    <>
      <STHead
        title={metaTitle}
        description={metaDescription}
        keywords={metaKeywords}
        canonicalUrl="https://sustanix.com/news-feed/"
        ogTitle={ogTitle}
        ogDescription={ogDescription}
        ogKeywords={ogKeywords}
        ogUrl="https://sustanix.com/news-feed/"
        ogImage={ogImage}
        ogType="website"
      />
      <STNewsFeed pageData={pageData} />
    </>
  );
};

export default NewsFeed;
